import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwContactBox extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {
            activeClass: 'is-active',
            openHandleClass: 'contact-box__figure',
            closeHandleClass: 'contact-box__button-close',
            mobileHeaderClass: 'mobile-header'
        }

    }

    __PageReady(){
        var mobileHeadClicker = $('<div class="mobile-header__contact"><div class="contact-box__figure"><i class="fa fa-phone" aria-hidden="true"></i></div></div>')
        if(!$('.'+this.config.mobileHeaderClass).find(".mobile-header__contact").length){
            $('.'+this.config.mobileHeaderClass).append(mobileHeadClicker);
        }
        $("."+this.config.openHandleClass).on("click",this.toggleContactBox.bind(this));
        $("."+this.config.closeHandleClass).on("click",this.toggleContactBox.bind(this));
    }

    toggleContactBox() {
        this.$el.toggleClass(this.config.activeClass);

        if (parseInt(this.$el.css('right')) !== 0) {
            this.$el.toggleClass("slideInLeft");
        } else if (parseInt(this.$el.css('top')) == 0) {
            this.$el.toggleClass("slideInDown");
        } else {
            this.$el.toggleClass("slideInRight");
        }


    }



}

